export const send = {
    "v": "5.9.6",
    "fr": 60,
    "ip": 0,
    "op": 120,
    "w": 750,
    "h": 750,
    "nm": "Main render",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Layer 2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": 0.667,
                                "y": 1
                            },
                            "o": {
                                "x": 0.333,
                                "y": 0
                            },
                            "t": 8,
                            "s": [
                                -305,
                                1043,
                                0
                            ],
                            "to": null,
                            "ti": null
                        },
                        {
                            "i": {
                                "x": 0.667,
                                "y": 1
                            },
                            "o": {
                                "x": 0.333,
                                "y": 0
                            },
                            "t": 18,
                            "s": [
                                429,
                                325,
                                0
                            ],
                            "to": null,
                            "ti": null
                        },
                        {
                            "t": 28,
                            "s": [
                                375,
                                375,
                                0
                            ]
                        }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        375,
                        375,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            -59.309,
                                            52.414
                                        ],
                                        [
                                            59.309,
                                            -52.414
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -59.309,
                                            52.414
                                        ],
                                        [
                                            59.309,
                                            -52.414
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -59.309,
                                            52.414
                                        ],
                                        [
                                            59.309,
                                            -52.414
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 35,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    400.781,
                                    334.401
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            236.439,
                                            -254.176
                                        ],
                                        [
                                            -221.249,
                                            -161.324
                                        ],
                                        [
                                            -268.13,
                                            -98.311
                                        ],
                                        [
                                            -33.528,
                                            11.815
                                        ],
                                        [
                                            34.148,
                                            219.085
                                        ],
                                        [
                                            102.14,
                                            258.396
                                        ],
                                        [
                                            253.197,
                                            -192.232
                                        ]
                                    ],
                                    "o": [
                                        [
                                            204.23,
                                            -247.642
                                        ],
                                        [
                                            -261.553,
                                            -153.14700000000002
                                        ],
                                        [
                                            -230.902,
                                            -80.836
                                        ],
                                        [
                                            -33.528,
                                            11.815
                                        ],
                                        [
                                            46.913000000000004,
                                            258.17900000000003
                                        ],
                                        [
                                            115.211,
                                            219.403
                                        ],
                                        [
                                            263.64300000000003,
                                            -223.393
                                        ]
                                    ],
                                    "v": [
                                        [
                                            204.23,
                                            -247.642
                                        ],
                                        [
                                            -221.249,
                                            -161.324
                                        ],
                                        [
                                            -230.902,
                                            -80.836
                                        ],
                                        [
                                            -33.528,
                                            11.815
                                        ],
                                        [
                                            34.148,
                                            219.085
                                        ],
                                        [
                                            115.211,
                                            219.403
                                        ],
                                        [
                                            253.197,
                                            -192.232
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 35,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    375,
                                    375
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 8,
            "op": 188,
            "st": 8,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Layer 1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": 0.833,
                                "y": 0.833
                            },
                            "o": {
                                "x": 0.167,
                                "y": 0.167
                            },
                            "t": 0,
                            "s": [
                                375,
                                375,
                                0
                            ],
                            "to": [
                                120.667,
                                -109.333,
                                0
                            ],
                            "ti": [
                                -120.667,
                                109.333,
                                0
                            ]
                        },
                        {
                            "t": 16,
                            "s": [
                                1099,
                                -281,
                                0
                            ]
                        }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        375,
                        375,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -59.309,
                                                        52.414
                                                    ],
                                                    [
                                                        59.309,
                                                        -52.414
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -59.309,
                                                        52.414
                                                    ],
                                                    [
                                                        59.309,
                                                        -52.414
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -59.309,
                                                        52.414
                                                    ],
                                                    [
                                                        59.309,
                                                        -52.414
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 11,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -53.085,
                                                        51.187
                                                    ],
                                                    [
                                                        41.933,
                                                        -40.393
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -53.085,
                                                        51.187
                                                    ],
                                                    [
                                                        41.933,
                                                        -40.393
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -53.085,
                                                        51.187
                                                    ],
                                                    [
                                                        41.933,
                                                        -40.393
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 40,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    400.781,
                                    334.401
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        236.439,
                                                        -254.176
                                                    ],
                                                    [
                                                        -221.249,
                                                        -161.324
                                                    ],
                                                    [
                                                        -268.13,
                                                        -98.311
                                                    ],
                                                    [
                                                        -33.528,
                                                        11.815
                                                    ],
                                                    [
                                                        34.148,
                                                        219.085
                                                    ],
                                                    [
                                                        102.14,
                                                        258.396
                                                    ],
                                                    [
                                                        253.197,
                                                        -192.232
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        204.23,
                                                        -247.642
                                                    ],
                                                    [
                                                        -261.553,
                                                        -153.14700000000002
                                                    ],
                                                    [
                                                        -230.902,
                                                        -80.836
                                                    ],
                                                    [
                                                        -33.528,
                                                        11.815
                                                    ],
                                                    [
                                                        46.913000000000004,
                                                        258.17900000000003
                                                    ],
                                                    [
                                                        115.211,
                                                        219.403
                                                    ],
                                                    [
                                                        263.64300000000003,
                                                        -223.393
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        204.23,
                                                        -247.642
                                                    ],
                                                    [
                                                        -221.249,
                                                        -161.324
                                                    ],
                                                    [
                                                        -230.902,
                                                        -80.836
                                                    ],
                                                    [
                                                        -33.528,
                                                        11.815
                                                    ],
                                                    [
                                                        34.148,
                                                        219.085
                                                    ],
                                                    [
                                                        115.211,
                                                        219.403
                                                    ],
                                                    [
                                                        253.197,
                                                        -192.232
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 11,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        188.951,
                                                        -221.78900000000002
                                                    ],
                                                    [
                                                        -177.675,
                                                        -140.67
                                                    ],
                                                    [
                                                        -215.22899999999998,
                                                        -85.621
                                                    ],
                                                    [
                                                        -27.303,
                                                        10.588
                                                    ],
                                                    [
                                                        26.907,
                                                        191.665
                                                    ],
                                                    [
                                                        81.373,
                                                        226.007
                                                    ],
                                                    [
                                                        202.375,
                                                        -167.672
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        163.15,
                                                        -216.08
                                                    ],
                                                    [
                                                        -209.96,
                                                        -133.527
                                                    ],
                                                    [
                                                        -185.408,
                                                        -70.354
                                                    ],
                                                    [
                                                        -27.303,
                                                        10.588
                                                    ],
                                                    [
                                                        37.132,
                                                        225.819
                                                    ],
                                                    [
                                                        91.843,
                                                        191.942
                                                    ],
                                                    [
                                                        210.742,
                                                        -194.89499999999998
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        163.15,
                                                        -216.08
                                                    ],
                                                    [
                                                        -177.675,
                                                        -140.67
                                                    ],
                                                    [
                                                        -185.408,
                                                        -70.354
                                                    ],
                                                    [
                                                        -27.303,
                                                        10.588
                                                    ],
                                                    [
                                                        26.907,
                                                        191.665
                                                    ],
                                                    [
                                                        91.843,
                                                        191.942
                                                    ],
                                                    [
                                                        202.375,
                                                        -167.672
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 35,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    375,
                                    375
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 180,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        }
    ],
    "markers": [],
    "__complete": true
}